<template>
    <div>
        <div class="color-grid">
            <button
                v-for="color in tailwindColors"
                :key="color.name"
                class="color-button"
                :style="{ backgroundColor: color.hex }"
                @click.stop="selectColor(color.hex)"
            ></button>
        </div>
        <div class="mt-2">
            <b-button size="sm" variant="outline" @click.stop="showCustomColorInput = !showCustomColorInput">
                Custom Color
            </b-button>
        </div>
        <div v-if="showCustomColorInput" class="mt-2">
            <b-input-group size="sm">
                <b-form-input v-model="customColor" type="color" style="max-width: 100px;"></b-form-input>
                <b-input-group-append>
                    <b-button variant="primary" @click.stop="selectColor(customColor)">Set</b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColorChooser',
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tailwindColors: [
                { name: 'slate-400', hex: '#94a3b8' },
                { name: 'gray-400', hex: '#9ca3af' },
                { name: 'zinc-400', hex: '#a1a1aa' },
                { name: 'neutral-400', hex: '#a3a3a3' },
                { name: 'stone-400', hex: '#a8a29e' },
                { name: 'red-400', hex: '#f87171' },
                { name: 'orange-400', hex: '#fb923c' },
                { name: 'amber-400', hex: '#fbbf24' },
                { name: 'yellow-400', hex: '#facc15' },
                { name: 'lime-400', hex: '#a3e635' },
                { name: 'green-400', hex: '#4ade80' },
                { name: 'emerald-400', hex: '#34d399' },
                { name: 'teal-400', hex: '#2dd4bf' },
                { name: 'cyan-400', hex: '#22d3ee' },
                { name: 'sky-400', hex: '#38bdf8' },
                { name: 'blue-400', hex: '#60a5fa' },
                { name: 'indigo-400', hex: '#818cf8' },
                { name: 'violet-400', hex: '#a78bfa' },
                { name: 'purple-400', hex: '#c084fc' },
                { name: 'fuchsia-400', hex: '#e879f9' },
                { name: 'pink-400', hex: '#f472b6' },
                { name: 'rose-400', hex: '#fb7185' }
            ],
            showCustomColorInput: false,
            customColor: this.value
        };
    },
    methods: {
        selectColor(color) {
            this.$emit('input', color);
        }
    }
};
</script>

<style scoped>
.color-grid {
    display: inline-grid;
    grid-template-columns: repeat(11, auto);
    gap: 5px;
    justify-content: start;
}
.color-button {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #ccc;
    cursor: pointer;
    padding: 0;
}
</style>